import React from 'react';
import {allApplications} from '../applications/ApplicationList.js';
import '../desktop-components-css/Taskbar.css';

function getComponentIcon(appName) {
  let appObject = allApplications.find(obj => obj.name === appName);
  let defaultIcon = appObject.smallIcon;
  return defaultIcon;
}

class Taskbar extends React.Component {
  constructor(props) {
    super(props);
    this.taskbarFunctionHandler = this.taskbarFunctionHandler.bind(this);
  }

  taskbarFunctionHandler(e, index) {
    if(this.props.openApplications[index].zIndex === -1) {
      this.props.appFocusHandler(index);
    }
    else {
      this.props.appMinimizeHandler(e, index);
    }
  }

  render() {
    return (
      <div id="taskbar">
        <button id="start" onClick = {this.props.startButtonHandler}> Start </button>
        <div id="appButtons">
          {this.props.openApplications.map((value, index) => {
            if(value != null) {
              if(value.appObject.windowType === "Application") {
                let buttonTitle = "taskbar-" + value.name + "-" + index
                return (
                  <button
                    data-testid = {buttonTitle}
                    key = {index}
                    onClick = {e => this.taskbarFunctionHandler(e, index)}>
                    <div id="buttonContents">
                      <img src={getComponentIcon(value.name)} draggable="false" alt={value}/>
                      <div id="buttonText">{value.name}</div>
                    </div>
                  </button>
                );
              }
            }
            else {
              return(null);
            }
          })}
        </div>
      </div>
    );
  }
}

export default Taskbar;
